import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { PayeePopupComponent } from '../../../shared/payee-popup/payee-popup.component';
import { PayeeFormFieldComponent } from '../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeCopyFormFieldComponent } from '../../../shared/payee-form-fields/payee-copy-form-field/payee-copy-form-field.component';
import { PayeeButtonComponent } from '../../../shared/payee-buttons/payee-button/payee-button.component';
import { PayeeIconComponent } from '../../../shared/payee-icon/payee-icon.component';
import { TranslateModule } from '@ngx-translate/core';

export type TransferInstructionsDialogData = {
  credit_transfer_id: string;
  amount: number;
  currency_iso: string;
};

@Component({
  selector: 'app-transfer-instructions-dialog',
  templateUrl: './transfer-instructions-dialog.component.html',
  styleUrls: ['./transfer-instructions-dialog.component.scss'],
  imports: [
    PayeePopupComponent,
    FormsModule,
    ReactiveFormsModule,
    PayeeFormFieldComponent,
    PayeeCopyFormFieldComponent,
    PayeeButtonComponent,
    MatDialogClose,
    PayeeIconComponent,
    TranslateModule,
  ],
})
export class TransferInstructionsDialogComponent {
  private fb = inject(FormBuilder);
  data = inject<TransferInstructionsDialogData>(MAT_DIALOG_DATA);

  readonly form = this.fb.group({
    transfer_amount: this.fb.control(this.data.amount, { nonNullable: true }),
    currency_iso: this.fb.control(this.data.currency_iso, {
      nonNullable: true,
    }),
    account_holder_name: this.fb.control('Legal Labs Kft.', {
      nonNullable: true,
    }),
    account_number: this.fb.control('12600016-19259526-84463815', {
      nonNullable: true,
    }),
    credit_transfer_id: this.fb.control(this.data.credit_transfer_id, {
      nonNullable: true,
    }),
  });
}
